import React from 'react'
// HEADER
import HeaderReturn from '../../../components.js/serveur/siteWeb/HeaderReturn'

const VacancesEquipe = () => {
    return (
        <div className='container-fluid'>

            {/* HEADER */}
            <HeaderReturn title='Vancances' link='/homePageEquipe' /> 

        </div>
    )
}

export default VacancesEquipe